import { render, staticRenderFns } from "./CommentAttachmentsInput.vue?vue&type=template&id=074ba4ef&scoped=true&"
import script from "./CommentAttachmentsInput.vue?vue&type=script&lang=js&"
export * from "./CommentAttachmentsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ba4ef",
  null
  
)

export default component.exports